import { useEffect, useState } from "react";
import Heading from "../../components/layout/Heading";
import BlueButton from "../../components/buttons/BlueButton";
import GreyButton from "../../components/buttons/GreyButton";
import ActiveButtonIcon from "../../components/icons/ActiveButtonIcon";
import PinkEye from "../../components/assets/eyes/PinkEye";
import BlueEye from "../../components/assets/eyes/BlueEye";
import LightBlueEye from "../../components/assets/eyes/LightBlueEye";
import WorksPageGrid from "../WorksPageGrid";
import { useParams } from "react-router-dom";
import ButtonLayout from "../../components/buttons/ButtonLayout";
import clsx from "clsx";
import axios from "axios";
import { BASE_URL, decodeHtmlEntities, stripHtmlTags } from "../../globals";
import { ThreeDots } from "react-loader-spinner";
import Loader from "../../components/assets/Loader";

export default function WorksPage() {
    const { service } = useParams()
    const [categories, setCategories] = useState([]);
    const [currentCategory, setCurrentCategory] = useState(null);
    const [items, setItems] = useState([]);
    const [all, setAll] = useState(true);
    const [isLoading, setIsLoading] = useState(true);

    async function getItems(taxonomy_id = null) {
        setIsLoading(true);
        const post_type = "realisation";
        let url = `${BASE_URL}/${post_type}`;
        if (taxonomy_id) {
            const taxonomy_name = "service";
            url = url + `?${taxonomy_name}=${taxonomy_id}`
        }
        try {
            const response = await axios.get(url);
            const data = [...response.data].map((post) => {
                return {
                    name: decodeHtmlEntities(post.title.rendered),
                    slug: post.slug,
                    description: post.excerpt ? stripHtmlTags(post.excerpt.rendered) : null,
                    featured_media: post.featured_media
                }
            });
            for (let post of data) {
                const media = await axios.get(`${BASE_URL}/media/${post.featured_media}`);
                post.thumbnail = media.data.source_url;
            }
            setItems(data);
        } catch (err) {
            console.log(err);
        }
        setIsLoading(false);
    }

    async function fetchCategories() {
        const taxonomy = "service"
        try {
            const response = await axios.get(`${BASE_URL}/${taxonomy}`);
            const classNames = {
                "communication": "bg-zoeil-blue",
                "graphisme": "bg-zoeil-pink",
                "web-design": "bg-zoeil-light-blue",
                "photo-video": "bg-zoeil-yellow"
            };
            const data = [...response.data].map((term) => {
                return {
                    id: term.id,
                    label: decodeHtmlEntities(term.name),
                    slug: term.slug,
                    className: classNames[term.slug]
                }
            });
            if(service){
                setCurrentCategory([...data].find(term=>term.slug===service));
            }
            setCategories(data);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        if(categories.length > 1){
            if (currentCategory) {
                setAll(false);
            } else {
                setAll(true);
            }
            getItems(currentCategory ? currentCategory.id : null);
        }
    }, [currentCategory,categories]);

    useEffect(() => {
        fetchCategories();
    }, []);

    function allTrigger() {
        setCurrentCategory(null);
    }

    return (
        <>
            <div className="relative my-16 w-fit mx-auto px-48 mobile:px-3">
                <div className="w-full max-w-[1470px] mx-auto flex flex-col justify-center mobile:px-8">
                    <div className="w-full relative">
                        <Heading
                            title="Envie de voir nos réalisations ?"
                            highlighted_words={["réalisations"]}
                            subtitle="Je sais, tu vas penser qu’il y en a beaucoup mais bon on t’a dit qu’on savait travailler quand il fallait !" />
                    </div>
                </div>
                {!isLoading ?
                    <div className="flex justify-center gap-[2.125rem] flex-wrap">
                        <button className="w-fit" onClick={() => {
                            allTrigger();
                        }}>
                            {all ? <BlueButton icon={<ActiveButtonIcon />}>
                                Tout
                            </BlueButton>
                                : <GreyButton>
                                    Tout
                                </GreyButton>}
                        </button>
                        {categories.map(v =>
                            <button onClick={() => {
                                setCurrentCategory(v);
                            }} key={v.id}>
                                {(currentCategory && v.slug === currentCategory.slug) ? <ButtonLayout icon={<ActiveButtonIcon />} className={clsx(
                                    "text-white",
                                    v.className
                                )}>
                                    {v.label}
                                </ButtonLayout>
                                    : <GreyButton>
                                        {v.label}
                                    </GreyButton>}
                            </button>
                        )}
                    </div> :
                    <div className="flex justify-center">
                        <Loader/>
                    </div>}
                <div className="w-[6.25rem] mobile:w-[3rem] aspect-square absolute top-0 left-3 rotate-[45deg]">
                    <PinkEye version={2} />
                </div>
                <div className="w-[6.25rem] mobile:w-[3rem] aspect-square absolute bottom-0 right-3 rotate-[10deg] -scale-x-[1]">
                    <LightBlueEye version={3} />
                </div>
            </div>
            {!isLoading && <WorksPageGrid items={items} />}
        </>
    )
}